import { CHARACTER_EDIT_RELATE } from "constant/character/character.constant";
import { useLocalStorageValue } from "hooks/hook_util/local_storage/useLocalStorageEntry";
import React from "react";

type UseCharacterItemModeResponse = {
  relateEdit: string | null;
  relateNav: string | null;
  editNav: string | null;
};

export function useCharacterItemMode(
  isRelatePlay?: boolean
): UseCharacterItemModeResponse {
  const relateEdit = useLocalStorageValue(CHARACTER_EDIT_RELATE.RELATE_EDIT);
  const relateNav = useLocalStorageValue(CHARACTER_EDIT_RELATE.RELATE_NAV);
  const editNav = useLocalStorageValue(CHARACTER_EDIT_RELATE.EDIT_NAV);

  React.useEffect(() => {
    const direcReadValue = localStorage.getItem(
      CHARACTER_EDIT_RELATE.RELATE_NAV
    );
    console.log(
      "ruseCharacterItemMode relateNav, direcReadValue, key",
      relateNav,
      direcReadValue,
      CHARACTER_EDIT_RELATE.RELATE_NAV
    );
  }, [relateNav, relateEdit]);

  const response: UseCharacterItemModeResponse = {
    relateEdit: null,
    relateNav: null,
    editNav: null,
  };

  if (!isRelatePlay) {
    response.relateEdit = relateEdit;
    response.relateNav = relateNav;
    response.editNav = editNav;
  }

  return response;
}
